import { Mail, Instagram, MessageCircle } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { CONTACT } from "@/data/site";

export default function Contact() {
  const wa = CONTACT.whatsappNumber ? `https://wa.me/${CONTACT.whatsappNumber.replace(/[^\d]/g, "")}` : null;
  return (
    <section id="contatti" className="py-24 md:py-32 bg-brand-olive text-brand-white">
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
        <Reveal>
          <p className="text-xs tracking-[0.35em] uppercase text-brand-gold mb-4">Contatti</p>
          <h2 className="font-heading font-light text-4xl md:text-5xl">Contatta Martelli Rentals</h2>
          <p className="mt-5 text-white/80 max-w-2xl mx-auto text-lg">Per informazioni sulle strutture, soggiorni personalizzati o assistenza alla prenotazione, puoi contattarci direttamente.</p>
        </Reveal>
        <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
          <a data-testid="contact-email" href={`mailto:${CONTACT.email}`} className="inline-flex items-center justify-center gap-2 bg-brand-white text-brand-olive hover:bg-brand-ivory transition-colors rounded-full px-7 py-3.5 font-medium">
            <Mail className="w-4 h-4" /> Scrivici via e-mail
          </a>
          {wa ? (
            <a data-testid="contact-whatsapp" href={wa} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 border border-white/60 text-white hover:bg-white hover:text-brand-olive transition-colors rounded-full px-7 py-3.5 font-medium">
              <MessageCircle className="w-4 h-4" /> Contattaci su WhatsApp
            </a>
          ) : (
            <span className="inline-flex items-center justify-center gap-2 border border-white/30 text-white/60 rounded-full px-7 py-3.5">Numero in aggiornamento</span>
          )}
          <a data-testid="contact-instagram" href={CONTACT.instagramUrl} target="_blank" rel="noopener noreferrer" aria-label="Segui Martelli Rentals su Instagram" className="inline-flex items-center justify-center gap-2 border border-white/60 text-white hover:bg-white hover:text-brand-olive transition-colors rounded-full px-7 py-3.5 font-medium">
            <Instagram className="w-4 h-4" /> Seguici su Instagram
          </a>
        </div>
        <p className="mt-8 text-sm text-white/60">{CONTACT.email} · @{CONTACT.instagram}</p>
      </div>
    </section>
  );
}
